import {
  SendDatabaseDeleteEntryEventSources,
  sendDeleteEntryEvent,
  type AnalyticsClient,
} from '@databases/analytics';
import {
  DatabaseTraceAction,
  DatabaseTraceSource,
  traceDatabaseAction,
} from '@databases/frontend-metrics/perf-tracing';
import { doDeleteEntries } from '@databases/redux/contextual-menu/actions';
import { appStore } from '@databases/redux/store';
import { getService } from '@databases/service-container';

import { type CellContextMenuContext } from '../types';

/**
 * Handles the deletion of entries from the database via the context menu.
 *
 * This shared helper is used by context menu items to clear values associated with a given entry.
 * It checks if the entry is currently selected, hides the panel if necessary, dispatches the delete action,
 * and sends an analytics event for the deletion.
 */
export function deleteEntries({
  contentId,
  panelEntryId,
  client,
  hidePanel,
}: {
  contentId: string;
  panelEntryId: string;
  client: AnalyticsClient;
  hidePanel: CellContextMenuContext['panelManager']['hidePanel'];
}): void {
  if (getService('SelectionsReader').isEntryInSelection(panelEntryId)) {
    hidePanel();
  }

  traceDatabaseAction(
    { action: DatabaseTraceAction.EntryDelete, source: DatabaseTraceSource.ValueMenu },
    () => {
      appStore.dispatch(doDeleteEntries(contentId));
    }
  );

  void sendDeleteEntryEvent(
    client,
    SendDatabaseDeleteEntryEventSources.ENTRY_CONTEXTUAL_MENU,
    appStore.getState(),
    contentId
  );
}
